"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _shortCssVars = _interopRequireDefault(require("@ux/short-css-vars"));
var _stringHash = _interopRequireDefault(require("string-hash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
let shortVarsInstance;
const formatter = name => 'ux-' + (0, _stringHash.default)(name).toString(36);

/**
 * Convert a dot-notation Intent to a CSS Custom Property
 * @param {Array<String>|String} intent - A dot-notation Intent path as a string
 * @returns {String} - A CSS Custom Property
 */
function toCssCustomProperty(intent) {
  if (!shortVarsInstance) {
    shortVarsInstance = new _shortCssVars.default({
      formatter
    });
  }
  const parts = Array.isArray(intent) ? intent.filter(Boolean) : intent.toString().split('.');
  if (parts[0].startsWith('intent')) {
    parts.shift();
  }
  parts[parts.length - 1] = `-${parts[parts.length - 1]}`;
  return shortVarsInstance.replaceName(`--${parts.join('-')}`);
}
var _default = exports.default = toCssCustomProperty;